{
  "coursesPage": {
    "delete": {
      "title": "Eliminar curso",
      "description": "¿Seguro que quieres eliminar este curso?",
      "confirm": "Eliminar"
    },
    "toasts": {
      "archived": "Curso archivado",
      "unarchived": "Curso desarchivado: ha vuelto a borrador",
      "bulkPublished_one": "{{count}} curso publicado",
      "bulkPublished_zero": "{{count}} cursos publicados",
      "bulkPublished_other": "{{count}} cursos publicados",
      "noDraftSelected": "No hay ningún borrador seleccionado",
      "mergeSameTarget": "Selecciona cursos distintos del de destino",
      "mergeError": "Error al fusionar los cursos"
    },
    "header": {
      "title": "Cursos",
      "subtitle": "Gestiona tus cursos y contenidos",
      "publishSelected": "Publicar ({{count}})",
      "mergeTooltip": "Convierte los cursos seleccionados en módulos de un curso existente",
      "mergeSelected": "Fusionar como módulos ({{count}})",
      "mergeShort": "Fusionar",
      "publishAll": "Publicar todos",
      "newCourse": "Nuevo curso"
    },
    "filters": {
      "searchPlaceholder": "Buscar cursos...",
      "filter": "Filtrar",
      "all": "Todos",
      "draft": "Borrador",
      "published": "Publicado",
      "archived": "Archivado"
    },
    "merge": {
      "title": "Fusionar como módulos",
      "description_one": "El curso seleccionado se convertirá en un módulo dentro del curso de destino.",
      "description_zero": "Los {{count}} cursos seleccionados se convertirán en módulos dentro del curso de destino.",
      "description_other": "Los {{count}} cursos seleccionados se convertirán en módulos dentro del curso de destino.",
      "targetLabel": "Curso de destino",
      "targetPlaceholder": "Selecciona el curso de destino...",
      "targetHint": "Cada curso seleccionado se convierte en un módulo dentro del curso de destino.",
      "listTitle": "Se convertirán en módulo:",
      "cancel": "Cancelar",
      "convert": "Convertir"
    },
    "grid": {
      "selectedCount_one": "{{count}} seleccionado",
      "selectedCount_zero": "{{count}} seleccionados",
      "selectedCount_other": "{{count}} seleccionados",
      "selectAll": "Seleccionar todos",
      "pagination": "Página {{page}} de {{totalPages}} ({{total}} cursos)",
      "previous": "Anterior",
      "next": "Siguiente",
      "emptyTitle": "No se encontró ningún curso",
      "emptySearch": "Prueba con otra búsqueda",
      "emptyHint": "Empieza creando tu primer curso",
      "createCourse": "Crear curso"
    }
  },
  "courseEdit": {
    "status": {
      "draft": "Borrador",
      "published": "Publicado",
      "archived": "Archivado"
    },
    "loading": "Cargando curso...",
    "notFound": "Curso no encontrado",
    "backToCourses": "Volver a los cursos",
    "breadcrumb": "Cursos",
    "appearance": "Apariencia",
    "viewAsStudent": "Ver como alumno",
    "tabs": {
      "basic": "Información",
      "content": "Contenido",
      "community": "Comunidad"
    },
    "basic": {
      "updated": "Curso actualizado",
      "saveError": "Error al guardar el curso",
      "save": "Guardar cambios"
    },
    "sectionDialog": {
      "editTitle": "Editar sección",
      "newTitle": "Nueva sección",
      "titleLabel": "Título *",
      "titlePlaceholder": "Ej.: Fundamentos de React",
      "cancel": "Cancelar",
      "save": "Guardar",
      "create": "Crear"
    },
    "linkModule": {
      "defaultTitle": "Vincular sección existente",
      "defaultDescription": "Selecciona una sección para vincularla a este curso",
      "searchPlaceholder": "Buscar...",
      "counts": "{{lessons}} clases · {{courses}} cursos",
      "link": "Vincular",
      "noResults": "No se encontraron resultados",
      "allLinked": "Ya están todos vinculados"
    },
    "content": {
      "errors": {
        "reorderSections": "Error al reordenar los módulos",
        "reorderChildren": "Error al reordenar los submódulos",
        "deleteSection": "Error al eliminar la sección",
        "unlinkSection": "Error al desvincular la sección",
        "saveSection": "Error al guardar la sección",
        "linkSection": "Error al vincular la sección",
        "linkModule": "Error al vincular el módulo",
        "unlinkModule": "Error al desvincular el módulo"
      },
      "deleteSection": {
        "title": "Eliminar sección",
        "description": "¿Seguro que quieres eliminar esta sección y todo su contenido?",
        "confirm": "Eliminar"
      },
      "unlinkSection": {
        "title": "Desvincular sección",
        "description": "La sección se quitará de este curso, pero seguirá existiendo. ¿Quieres continuar?",
        "confirm": "Desvincular"
      },
      "unlinkModule": {
        "title": "Desvincular módulo",
        "description": "El módulo se quitará de esta sección, pero seguirá existiendo. ¿Quieres continuar?",
        "confirm": "Desvincular"
      },
      "sectionsCount_one": "{{count}} sección",
      "sectionsCount_zero": "{{count}} secciones",
      "sectionsCount_other": "{{count}} secciones",
      "lessonsCount_one": "{{count}} clase",
      "lessonsCount_zero": "{{count}} clases",
      "lessonsCount_other": "{{count}} clases",
      "modulesCount_one": "{{count}} módulo",
      "modulesCount_zero": "{{count}} módulos",
      "modulesCount_other": "{{count}} módulos",
      "sharedCourses_one": "{{count}} curso",
      "sharedCourses_zero": "{{count}} cursos",
      "sharedCourses_other": "{{count}} cursos",
      "newSection": "Nueva sección",
      "linkSection": "Vincular sección",
      "loading": "Cargando...",
      "editSectionTitle": "Editar sección",
      "unlinkSectionTitle": "Desvincular sección",
      "deleteSectionTitle": "Eliminar sección",
      "linkModule": "Vincular módulo",
      "unlinkModuleTitle": "Desvincular módulo",
      "noModules": "No hay ningún módulo vinculado a esta sección",
      "emptyTitle": "Todavía no creaste ninguna sección",
      "emptyHint": "Crea secciones para organizar el contenido del curso",
      "createSection": "Crear sección",
      "linkExisting": "Vincular existente",
      "linkModuleDialog": {
        "title": "Vincular módulo",
        "description": "Selecciona un módulo para vincularlo a esta sección"
      }
    },
    "community": {
      "unavailable": {
        "locked": "escaparate bloqueado",
        "noPosts": "no admite publicaciones"
      },
      "notConfigured": {
        "title": "Comunidad no configurada",
        "description": "Define la variable <code>COMMUNITY_SSO_SECRET</code> en el backend y reinicia el servidor para habilitar la vinculación entre rutas y espacios de la comunidad."
      },
      "linked": "Espacio vinculado al curso",
      "unlinked": "Vínculo con la comunidad eliminado",
      "saveError": "Error al guardar el vínculo",
      "spaceLabel": "Espacio de la comunidad",
      "loadingSpaces": "Cargando espacios...",
      "chooseSpace": "Elige un espacio",
      "none": "Ninguno (sin comunidad en esta ruta)",
      "hint": "Este es el espacio predeterminado del curso. Cada módulo puede sobrescribir esta elección en su propia pestaña Comunidad: cuando el módulo tiene un espacio definido, prevalece sobre el del curso.",
      "noSpaces": "No se encontró ningún espacio en la comunidad. Crea uno allí para poder vincularlo aquí.",
      "save": "Guardar cambios"
    }
  },
  "courseForm": {
    "validation": {
      "titleMin": "El título debe tener al menos 3 caracteres",
      "bannerRequired": "El banner es obligatorio para los cursos publicados"
    },
    "title": "Título *",
    "titlePlaceholder": "Ej.: React avanzado",
    "shortDescription": "Descripción corta",
    "shortDescriptionPlaceholder": "Una breve descripción del curso",
    "description": "Descripción completa",
    "descriptionPlaceholder": "Describe el contenido del curso en detalle...",
    "images": {
      "title": "Imágenes del curso",
      "subtitle": "Añade imágenes en distintos formatos para que se vean mejor en la plataforma",
      "thumbnail": "Miniatura predeterminada",
      "thumbnailHint": "Imagen cuadrada/predeterminada del curso",
      "horizontal": "Miniatura horizontal (740x415px)",
      "horizontalHint": "Se usa en los banners y secciones horizontales (proporción 16:9)",
      "vertical": "Miniatura vertical",
      "verticalHint": "Vistas en celular y cuadrículas (proporción 9:16 o similar)",
      "banner": "Banner (1920px de ancho)",
      "bannerHint": "Carrusel principal a pantalla completa (proporción 21:9 o 16:9 panorámica)",
      "bannerRequired": "— Obligatorio para publicar"
    },
    "status": "Estado *",
    "statusPlaceholder": "Selecciona el estado",
    "statusOptions": {
      "draft": "Borrador",
      "published": "Publicado",
      "archived": "Archivado"
    },
    "trail": "Ruta de aprendizaje",
    "trailHint": "Activa la vista de ruta para los alumnos",
    "visibility": "Para quien no lo compró",
    "visibilityOptions": {
      "locked": "Visible con bloqueo",
      "hidden": "Oculto"
    },
    "visibilityHints": {
      "locked": "Aparece en el catálogo con candado y botón de compra. El botón usa la oferta de Xtreed vinculada a un grupo de acceso de este curso.",
      "hidden": "Solo aparece para quien ya tiene acceso. El resto no ve el curso ni puede abrirlo por el enlace."
    }
  },
  "courseFormDialog": {
    "saveError": "Error al guardar el curso",
    "title": "Nuevo curso",
    "description": "Completa la información para crear un nuevo curso",
    "cancel": "Cancelar",
    "submit": "Crear curso"
  },
  "courseCard": {
    "status": {
      "draft": "Borrador",
      "published": "Publicado",
      "archived": "Archivado"
    },
    "selectAria": "Seleccionar {{title}}",
    "students_one": "<num>{{count}}</num> alumno",
    "students_zero": "<num>{{count}}</num> alumnos",
    "students_other": "<num>{{count}}</num> alumnos",
    "modules_one": "{{count}} módulo",
    "modules_zero": "{{count}} módulos",
    "modules_other": "{{count}} módulos",
    "lessons_one": "{{count}} clase",
    "lessons_zero": "{{count}} clases",
    "lessons_other": "{{count}} clases",
    "editAria": "Editar {{title}}",
    "edit": "Editar",
    "editTooltip": "Editar curso, información y contenido",
    "appearanceAria": "Editar la apariencia de {{title}}",
    "appearance": "Apariencia",
    "appearanceTooltip": "Página del curso, secciones y menú",
    "moreActionsAria": "Más acciones para {{title}}",
    "moreActions": "Más acciones",
    "viewAsStudent": "Ver como alumno",
    "publish": "Publicar",
    "archive": "Archivar",
    "unarchive": "Desarchivar",
    "mergeAsModule": "Fusionar como módulo",
    "delete": "Eliminar"
  },
  "levelForm": {
    "validation": {
      "nameRequired": "El nombre es obligatorio",
      "minPointsMin": "La puntuación mínima debe ser >= 0"
    },
    "updated": "¡Nivel actualizado correctamente!",
    "created": "¡Nivel creado correctamente!",
    "saveError": "Error al guardar el nivel",
    "editTitle": "Editar nivel",
    "createTitle": "Crear nivel",
    "description": "Configura los datos del nivel",
    "name": "Nombre del nivel",
    "namePlaceholder": "Ej.: Nivel 1",
    "minPoints": "Puntuación mínima",
    "maxPoints": "Puntuación máxima",
    "optional": "Opcional",
    "color": "Color (hex)",
    "order": "Orden",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "save": "Guardar",
    "create": "Crear"
  },
  "categories": {
    "toasts": {
      "created": "Categoría creada correctamente",
      "createError": "Error al crear la categoría",
      "updated": "Categoría actualizada correctamente",
      "updateError": "Error al actualizar la categoría",
      "deleted": "Categoría eliminada correctamente",
      "deleteError": "Error al eliminar la categoría"
    },
    "validation": {
      "nameMin": "El nombre debe tener al menos 2 caracteres"
    },
    "title": "Categorías",
    "subtitle": "Gestiona las categorías de tus cursos",
    "new": "Nueva categoría",
    "emptyTitle": "Ninguna categoría",
    "emptyHint": "Crea tu primera categoría para organizar los cursos",
    "create": "Crear categoría",
    "coursesCount_one": "{{count}} curso",
    "coursesCount_zero": "{{count}} cursos",
    "coursesCount_other": "{{count}} cursos",
    "dialog": {
      "editTitle": "Editar categoría",
      "newTitle": "Nueva categoría",
      "editDescription": "Edita la información de la categoría",
      "newDescription": "Completa la información para crear una nueva categoría",
      "name": "Nombre *",
      "namePlaceholder": "Ej.: Desarrollo web",
      "description": "Descripción",
      "descriptionPlaceholder": "Una breve descripción de la categoría...",
      "color": "Color",
      "customColor": "O elige un color personalizado",
      "cancel": "Cancelar",
      "save": "Guardar",
      "create": "Crear"
    },
    "delete": {
      "title": "¿Eliminar categoría?",
      "description": "¿Seguro que quieres eliminar la categoría <bold>{{name}}</bold>? Los cursos asociados se quedarán sin categoría.",
      "cancel": "Cancelar",
      "confirm": "Eliminar"
    }
  },
  "trailForm": {
    "validation": {
      "titleRequired": "El título es obligatorio",
      "slugRequired": "El slug es obligatorio",
      "productRequired": "El producto es obligatorio"
    },
    "basicInfo": "Información básica",
    "title": "Título",
    "titlePlaceholder": "Nombre de la ruta",
    "slugPlaceholder": "nombre-de-la-ruta",
    "slugHint": "URL amigable para la ruta (se genera automáticamente)",
    "description": "Descripción",
    "descriptionPlaceholder": "Describe lo que el alumno aprenderá en esta ruta",
    "thumbnail": "Imagen de portada (URL)",
    "settings": "Configuración",
    "estimatedHours": "Tiempo estimado (horas)",
    "difficulty": "Dificultad",
    "difficultyPlaceholder": "Selecciona la dificultad",
    "difficultyOptions": {
      "beginner": "Principiante",
      "intermediate": "Intermedio",
      "advanced": "Avanzado"
    },
    "publish": "Publicar ruta",
    "publishHint": "Hace que la ruta sea visible para los estudiantes",
    "tags": "Etiquetas",
    "newTag": "Nueva etiqueta",
    "steps": {
      "title": "Cursos de la ruta",
      "add": "Añadir curso",
      "emptyTitle": "Todavía no agregaste ningún curso.",
      "emptyHint": "Haz clic en \"Añadir curso\" para empezar.",
      "course": "Curso",
      "coursePlaceholder": "Selecciona un curso",
      "delay": "Retraso (días)",
      "delayHint": "Días para desbloquear tras el paso anterior",
      "required": "Obligatorio"
    },
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "save": "Guardar ruta"
  }
}
